import React from "react";
import { bool, elementType, node, oneOf, oneOfType, string } from "prop-types";
import Link from "../Link";
import Icon from "../Icon";
import { classes } from "../utils/classes";

const PageNavbarLink = ({
	Tag = Link,
	iconName,
	rotateIcon = false,
	children,
	className = "",
	...props
}) => (
	<Tag className={classes("page-navbar-link", className)} {...props}>
		{iconName ? <Icon name={iconName} className={classes(rotateIcon && "rotated-45")} /> : null}
		<span>{children}</span>
	</Tag>
);

PageNavbarLink.propTypes = {
	Tag: oneOfType([oneOf(["a", "span", "button"]), elementType]),
	iconName: string,
	rotateIcon: bool,
	className: string,
	children: node,
};

export default PageNavbarLink;
